(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabs(container) {
    var links = container.querySelectorAll('.product-tabs__nav a');
    var panels = container.querySelectorAll('.product-tabs__panel');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = this.getAttribute('href');
        links.forEach(function (l) {
          l.classList.remove('active');
          l.setAttribute('aria-selected', 'false');
          l.setAttribute('tabindex', '-1');
        });
        panels.forEach(function (p) { p.classList.add('hidden'); });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        this.removeAttribute('tabindex');
        var panel = container.querySelector(target);
        if (panel) { panel.classList.remove('hidden'); }
      });
    });
    container.querySelectorAll('[data-vyrobca-popis]').forEach(function (el) {
      var btn = el.querySelector('.vyrobca-tab__read-more');
      if (!btn) { return; }
      btn.addEventListener('click', function () {
        el.querySelector('.vyrobca-tab__text-short').hidden = true;
        el.querySelector('.vyrobca-tab__text-full').hidden = false;
        btn.hidden = true;
      });
      btn.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); btn.click(); }
      });
    });
  }
  document.querySelectorAll('.product-tabs').forEach(initTabs);
})();

  } catch(e) { console.error(e); }
})();
})();
